export default __webpack_public_path__ + "static/media/full-logo-white.ff0761ce.svg";